import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputBase,
  Modal,
  Paper,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { createTheme } from "@mui/material/styles";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { v4 as uuid } from "uuid";
import Autocomplate from "../../../components/dropdown/Autocomplate";
import {
  AddUserRoleResponse,
  GetRolesNotExistInUserRolesResponse,
  GetUserRolesResponse,
} from "../../../models/role.model";
import { AddUserRole } from "../../../services/role.service";
import PermissionRoleTable from "./PermissionRoleTable";
import TabsEmptyStyle from "./TabsEmptyStyle";
import AutocomplateCheckbox from "../../../components/dropdown/AutocomplateCheckbox";
interface Props {
  userOfficeRoles: GetUserRolesResponse[];
  setUpdateGetUserOfficeRoles: any;
  userRoleOptions: GetRolesNotExistInUserRolesResponse[];
  setUserOfficeRoles: any;
}

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 500,
  },
  maxWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 500,
  },

  maxHeight: "70vh",
  minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
const Roles = ({
  userOfficeRoles,
  setUpdateGetUserOfficeRoles,
  userRoleOptions,
  setUserOfficeRoles,
}: Props) => {
  const [openModal, setOpenModal] = useState(false);
  const [valueUserRolesOptions, setValueUserRolesOptions] = useState<number[]>(
    []
  );
  const [searchTerm, setSearchTerm] = useState("");
  const history = useHistory<{ permissionUserId: number }>();
  const userId =
    history?.location?.state?.permissionUserId !== undefined
      ? history?.location?.state?.permissionUserId
      : Number(window.localStorage.getItem("PermissionUserId"));

  const [valueUserRoles, setValueUserRoles] = useState<any[]>([]);
  const handleAddNewUserOfficeRole = () => {
    addUserRoleMutate({
      userId: userId,
      roleId: valueUserRolesOptions,
    });
  };

  const { mutate: addUserRoleMutate } = useMutation(AddUserRole, {
    onSuccess: (data: AddUserRoleResponse[]) => {
      if (data) {
        setUserOfficeRoles([...userOfficeRoles, ...data]);
        setOpenModal(false);
        setValueUserRolesOptions([]);
        setValueUserRoles([]);
        setUpdateGetUserOfficeRoles(uuid());
      }
    },
    onError: () => {},
  });

  function changeValueUserRolesOptions(e: any, value: any) {
    setValueUserRolesOptions(e);
    setValueUserRoles(value);
  }

  const removeTag = (tagId: number) => {
    setValueUserRoles(valueUserRoles.filter((node) => node.id !== tagId));
    setValueUserRolesOptions(
      valueUserRolesOptions.filter((item) => item !== tagId)
    );
  };

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value.trim().toLocaleLowerCase());
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12} sx={{ display: "flex", gap: "1" }}>
          <Typography
            onClick={() =>
              userRoleOptions.length > 0
                ? setOpenModal(true)
                : toast.error("نقش سازمانی وجود ندارد")
            }
            color={"#28A745"}
            fontWeight={"bold"}
            padding={"0.5rem"}
            borderRadius={"5px"}
            sx={{
              cursor: "pointer",
              width: "fit-content",
              "&: hover": { color: "#fff", background: "#28A745" },
            }}
          >
            <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
            افزودن نقش سازمانی
          </Typography>
          <span className="seprator_gray"></span>
          <Paper
            elevation={0}
            style={{
              border: "1px solid #DAE0E4",
              display: "flex",
              borderRadius: "5px",
              height: "35px",
              width: "20vw",
            }}
            square={true}
          >
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                paddingX: "16px",
                height: "30px !important",
              }}
              placeholder="جستجو"
              onChange={handleSearchInput}
            />

            <IconButton
              type="button"
              sx={{ color: "#9AAFC4" }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid>
        {userOfficeRoles.length > 0 ? (
          <Grid item xs={12} marginTop={"1.9vh"} sx={{ background: "#F9FCFE" }}>
            <PermissionRoleTable
              userOfficeRoles={userOfficeRoles}
              setUpdateGetUserOfficeRoles={setUpdateGetUserOfficeRoles}
              setUserOfficeRoles={setUserOfficeRoles}
              userId={userId}
              setSearchTerm={setSearchTerm}
              searchTerm={searchTerm}
            />
          </Grid>
        ) : (
          <TabsEmptyStyle text="نقش های سازمانی" />
        )}
      </Grid>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setValueUserRolesOptions([]);
          setValueUserRoles([]);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"3.8rem"}
          >
            <Grid item>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                fontWeight={"bold"}
                // marginY={"3rem"}
                fontSize={"14px"}
                color={"#1D4A87"}
              >
                افزودن نقش سازمانی
              </Typography>
            </Grid>

            <Grid item width={"100%"}>
              <CacheProvider value={cacheRtl}>
                <ThemeProvider theme={theme}>
                  <div dir="rtl">
                    <AutocomplateCheckbox
                      id="userRole"
                      name="userRole"
                      value={valueUserRolesOptions}
                      label="انتخاب نقش سازمانی"
                      options={userRoleOptions}
                      onChange={changeValueUserRolesOptions}
                      changeMultiSelect={changeValueUserRolesOptions}
                      responseValue={valueUserRoles}
                    />
                  </div>
                </ThemeProvider>
              </CacheProvider>
            </Grid>
            {valueUserRoles.length > 0 && (
              <Box
                sx={{
                  borderTop: "1px solid #CCD1D6",
                  width: "100%",
                  paddingTop: "2rem",
                }}
              >
                <Typography
                  sx={{
                    color: "#1D4A87",
                    marginTop: "10px",
                    fontWeight: "bold",
                    marginBottom: "10px",
                  }}
                >
                  پست های اضافه شده
                </Typography>
                <Grid
                  item
                  sx={{ display: "flex", gap: "7px", flexWrap: "wrap" }}
                >
                  {valueUserRoles.map((node) => (
                    <Box
                      sx={{
                        background: "#EDEFEF",
                        padding: "3px 7px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderRadius: "5px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {node.title}
                      <Typography
                        sx={{ cursor: "pointer" }}
                        onClick={() => removeTag(node.id)}
                      >
                        <ClearIcon
                          sx={{ color: "#34495E", fontSize: "14px" }}
                        />
                      </Typography>
                    </Box>
                  ))}
                </Grid>
              </Box>
            )}
            <Grid item width={"100%"}>
              <Grid
                container
                flexDirection={"row"}
                justifyContent={"center"}
                gap={"1rem"}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  maxWidth={"150px !important"}
                >
                  <Button
                    onClick={handleAddNewUserOfficeRole}
                    fullWidth
                    variant="contained"
                    disabled={userRoleOptions.length === 0}
                    className={
                      userRoleOptions.length === 0
                        ? "btnForm disabledBtn"
                        : "btnForm SuccessDefault"
                    }
                  >
                    ثبت
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  maxWidth={"150px !important"}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    style={{
                      fontSize: "1rem",
                      color: "#fff",
                      height: "40px",
                      background: "#607D8B",
                    }}
                    onClick={() => {
                      setOpenModal(false);
                      setValueUserRolesOptions([]);
                      setValueUserRoles([]);
                    }}
                  >
                    بازگشت
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default Roles;
